import type { DeckDef } from "@/decks/types";

// Presentación de credenciales de SOTA para la reunión con Coca-Cola Andina
// (6 de octubre de 2026). Portada + 7 slides + contraportada con contacto; dura cinco
// minutos y el resto es conversación. Mover una slide = mover su línea. Ocultarla =
// hidden: true. El copy vive en messages/es.json bajo deck.coca-cola-andina.*.
export const cocaColaAndinaDeck: DeckDef = {
  id: "coca-cola-andina",
  // Se abre solo con el link directo: no aparece en el manifest que consume la landing.
  listed: false,
  languages: ["es"],
  slides: [
    {
      id: "portada",
      load: () => import("./slides/PortadaSlide"),
    },
    {
      id: "quienes-somos",
      load: () => import("./slides/QuienesSomosSlide"),
    },
    {
      id: "como-funciona",
      load: () => import("./slides/ComoFuncionaSlide"),
    },
    {
      id: "pronostico",
      load: () => import("./slides/PronosticoSlide"),
    },
    {
      id: "variables",
      load: () => import("./slides/VariablesSlide"),
    },
    {
      id: "variables-detalle",
      load: () => import("./slides/VariablesDetalleSlide"),
    },
    {
      id: "como-trabajamos",
      load: () => import("./slides/ComoTrabajamosSlide"),
    },
    {
      id: "partner",
      load: () => import("./slides/PartnerSlide"),
    },
    {
      id: "contacto",
      load: () => import("./slides/ContactoSlide"),
    },
  ],
};
